// El bundle de `react-facebook-pixel` publica un source map con esquema
// `webpack://` que `source-map-loader` (CRA) no sabe resolver, lo que
// produce el warning de build:
//   "Failed to parse source map: 'webpack://ReactPixel/fb-pixel.js' URL is not supported"
// Es un problema del paquete publicado en npm, no de nuestro código, y solo
// afecta al mapeo de stack traces dentro de esa librería. Se ignora a propósito
// para no añadir CRACO/react-app-rewired únicamente por silenciar el aviso.
import ReactPixel from 'react-facebook-pixel';
const id=process.env.REACT_FACEBOOK_PIXEL_ID!;
ReactPixel.init('6821017527961991');

export const trackView=()=>{
    //ReactPixel.pageView();
}

export const purchaseCompleted=(cost:number)=>{
    ReactPixel.track('Purchase', {currency: "EUR", value: cost,eventID: Math.random()});
}

export const addToCart=()=>{
    ReactPixel.track('AddToCart',{eventID: Math.random()});
}

export const addPaymentInfo=()=>{
    ReactPixel.track('AddPaymentInfo',{eventID: Math.random()});
}